import { createContext } from 'react';
import { RecorderOutput } from '../util/output/recorder';

export const RecorderOutputContext = createContext<{output?: RecorderOutput}>({});